import { TextRangeOption } from 'trunks/vue/admin/components/logic_fields/option.js';

export default {
  components: {
    TextRangeOption,
  },

  data() {
    return {
      type: 'text',
      enableLimitSetting: false,
    };
  },

  created() {
    this._initLimitSettings();
  },

  computed: {
    enableUniquenessValidation() {
      return _.contains(this.field.validations, 'uniqueness');
    },

    limitSettingKey() {
      return this.field.type === 'Field::Integer' ? 'limit_settings' : 'char_size_limit_settings';
    },
  },

  methods: {
    setLimit(minValue, maxValue, mode) {
      this.resetLimitSettings();
      if (!(minValue || maxValue)) return;
      this.field.settings[this.limitSettingKey][mode] = mode === 'in' ? [minValue, maxValue] : minValue;
    },

    onTextLimitOptionBackdropClosedFunc(event) {
      if (!this.$el.contains(event.target)) {
        this.editing = false;
        Skylark.Helpers.App.removeCapturedBackdropByID(this._backdrop_id);
      }
    },

    getCheckRangeStatus() {
      this.toggleEnableLimitSetting();

      this.$nextTick(() => {
        if (this.enableLimitSetting) {
          this.$refs.optionRange.enableEditIfNeed();
        } else {
          this.field.settings[this.limitSettingKey] = {};
        }
      });
    },

    onOptionOpenedFunc(event) {
      this.$refs.fieldView.enableEdit(event);
    },

    resetLimitSettings() {
      this.field.settings[this.limitSettingKey] = {};
    },

    toggleSetting(key) {
      if (!this.field.settings.hasOwnProperty(key)) Vue.set(this.field.settings, key, null);
      this.field.settings[key] = !this.field.settings[key];
    },

    toggleEnableLimitSetting() {
      this.enableLimitSetting = !this.enableLimitSetting;
    },

    toggleUniquenessValidation() {
      if (this.enableUniquenessValidation) {
        this.field.validations = _.without(this.field.validations, 'uniqueness');
      } else {
        this.field.validations.push('uniqueness');
      }
    },

    _initLimitSettings() {
      if (this.field.settings[this.limitSettingKey] == null) this.field.settings[this.limitSettingKey] = {};
      this.enableLimitSetting = !(_.isEmpty(this.field.settings[this.limitSettingKey]));
    },

    _getFillSettingTitle(fillSetting) {
      return Skylark.Helpers.translate(`field.fillSetting.${fillSetting}.title`);
    },

    _getFillSettingTip(fillSetting) {
      return Skylark.Helpers.translate(`field.fillSetting.${fillSetting}.tip`);
    },
  },
};
